import useParams from '../../../hooks/useParamsAndCookies';
import { PayrollFilters } from './PRFilters';

const PRParams = () => {
  useParams<PayrollFilters>({
    tab: 'PR',
    params: [
      { label: 'reportType' },
      { label: 'employeeStatus' },
      { label: 'period' },
    ],
    cookieFiltersName: 'filters',
  });

  return <span />;
};

export default PRParams;
